export const includeIf = <T>(condition: boolean, action: T): T[] => (condition ? [action] : []);
